import { createRouter, createWebHistory } from 'vue-router'
import { setupLayouts } from 'virtual:generated-layouts'
import generatedRoutes from 'virtual:generated-pages'
import { useTalleresStore } from '@/stores/talleres'
import { useAuthStore } from '@/stores/auth'
import { miUsuario } from '@/services/usuarios'

// Process routes with layouts
const routes = setupLayouts(generatedRoutes)

routes.push(
  {
    path: '/admin/gestion-talleres',
    component: () => import('@/pages/admin/gestion-talleres/index.vue'),
    meta: {
      title: 'Crear Taller',
      requiresAuth: true
    }
  },
  {
    path: '/admin/gestion-talleres/lista',
    component: () => import('@/pages/admin/gestion-talleres/lista.vue'),
    meta: {
      title: 'Lista de Talleres',
      requiresAuth: true
    }
  },
  {
    path: '/admin/gestion-talleres/editar/:id',
    component: () => import('@/pages/admin/gestion-talleres/editar/[id].vue'),
    meta: {
      title: 'Editar Taller',
      requiresAuth: true
    }
  },
  {
    path: '/admin/cupones-cumpleanos',
    component: () => import('@/pages/admin/cupones-cumpleanos.vue'),
    meta: {
      title: 'Crear Cupón de Cumpleaños',
      requiresAuth: true
    }
  },
  {
    path: '/admin/alumnos-talleres',
    component: () => import('@/pages/admin/alumnos-talleres.vue'),
    meta: {
      title: 'Alumnos por Taller',
      requiresAuth: true,
      requiresAdminEmail: 'nchampane@gmail.com'
    }
  },
  {
    path: '/docentes/:taller/estadisticas',
    component: () => import('@/pages/docentes/[taller]/estadisticas.vue'),
    meta: {
      title: 'Estadísticas del Taller',
      requiresAuth: true,
      layout: 'docentes'
    }
  },
  {
    path: '/docentes/:taller/mis-alumnos',
    component: () => import('@/pages/docentes/[taller]/mis-alumnos.vue'),
    meta: {
      title: 'Mis Alumnos',
      requiresAuth: true,
      layout: 'docentes'
    }
  },
  {
    path: '/docentes/:taller/inicio',
    component: () => import('@/pages/docentes/[taller]/inicio.vue'),
    meta: {
      title: 'Detalle del Taller',
      requiresAuth: true,
      layout: 'docentes'
    }
  },
  {
    path: '/docentes/:taller',
    redirect: to => ({ path: `/docentes/${to.params.taller}/inicio` })
  }
)

// Create router
const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  }
})

// Error handler
router.onError((error) => {
  console.error('Vue Router error:', error)
})

// Router guard principal
router.beforeEach(async (to, from, next) => {
  const talleresStore = useTalleresStore()
  const authStore = useAuthStore()

  console.log('🛡️ Router guard - Verificando ruta:', to.path);
  console.log('🔗 Query params:', to.query);
  console.log('👤 Usuario actual:', authStore.usuario);
  console.log('🔐 Estado autenticación:', authStore.isAuthenticated);

  // Lógica específica para anecdotas de taller-marzo
  if (
    (to.path === "/virtuales/hernan-casciari/taller-marzo/anecdotas" || to.path === "/virtuales/hernan-casciari/taller-marzo/anecdotas/")
    && !to.params.id
  ) {
    console.log('🔄 Redirigiendo anecdotas de taller-marzo a mia');
    next({ path: "/virtuales/hernan-casciari/taller-marzo/anecdotas/mia" });
    return;
  }

  // Redirección específica para taller-septiembre/inicio a taller-octubre/inicio
  if (to.path === "/virtuales/hernán-casciari/taller-septiembre/inicio") {
    console.log('🔄 Redirigiendo taller-septiembre/inicio a taller-octubre/inicio');
    next({ path: "/virtuales/hernán-casciari/taller-octubre/inicio" });
    return;
  }

  // Excluir rutas de inscripciones de la verificación de autenticación
  if (to.path.startsWith('/inscripciones')) {
    console.log('✅ Ruta de inscripciones, permitiendo acceso');
    next()
    return
  }

  // Excluir rutas de mi-anecdota de la verificación de autenticación
  if (to.path.includes('/mi-anecdota')) {
    console.log('✅ Ruta de mi-anecdota detectada, permitiendo acceso sin verificación de autenticación');
    console.log('🔍 Detalles de la ruta:', {
      path: to.path,
      fullPath: to.fullPath,
      params: to.params,
      query: to.query
    });
    next()
    return
  }

  // Proteger el home de escuela (ruta /) - requiere autenticación
  // if (to.path === '/' || to.path === '') {
  //   console.log('🏠 Ruta home de escuela detectada, verificando autenticación...');
    
  //   try {
  //     // Verificar si el usuario está autenticado
  //     const isAuthenticated = await authStore.estaAutenticado()
  //     console.log('🔍 Resultado de estaAutenticado() para home:', isAuthenticated);
      
  //     if (!isAuthenticated) {
  //       console.log('❌ Usuario no autenticado, redirigiendo a talleres.orsai.org');
  //       // Redirigir a la URL externa de talleres
  //       window.location.href = 'https://talleres.orsai.org/';
  //       return
  //     }

  //     console.log('✅ Usuario autenticado, permitiendo acceso al home de escuela');
  //     // Continuar con la navegación normalmente
  //     next()
  //     return
  //   } catch (error) {
  //     console.error('❌ Error verificando autenticación para home:', error);
  //     // En caso de error, redirigir a talleres.orsai.org
  //     window.location.href = 'https://talleres.orsai.org/';
  //     return
  //   }
  // }

  // Verificar autenticación para rutas protegidas
  if (to.meta.requiresAuth || to.path.startsWith('/docente') || to.path.startsWith('/virtuales')) {
    console.log('🔐 Ruta protegida detectada, verificando autenticación...');
    
    try {
      // Verificar si el usuario está autenticado
      const isAuthenticated = await authStore.estaAutenticado()
      console.log('🔍 Resultado de estaAutenticado():', isAuthenticated);
      
      if (!isAuthenticated) {
        console.log('❌ Usuario no autenticado, redirigiendo al login');
        console.log('🔄 Redirigiendo a:', { 
          path: '/ingresar', 
          query: { redirect: to.fullPath }
        });
        // Si no está autenticado, redirigir al login con la ruta de retorno
        next({ 
          path: '/ingresar', 
          query: { redirect: to.fullPath }
        })
        return
      }

      console.log('✅ Usuario autenticado correctamente');

      // Rutas restringidas por email (solo un usuario específico)
      if (to.meta.requiresAdminEmail) {
        const emailActual = authStore.usuario?.email || '';
        if (emailActual !== to.meta.requiresAdminEmail) {
          console.log('❌ Acceso denegado: esta sección es solo para', to.meta.requiresAdminEmail);
          next({ path: '/' });
          return;
        }
      }

      // Si la ruta es /docente o comienza con /docente/, verificar si es docente
      if (to.path.startsWith('/docente')) {
        if (!authStore.usuario?.docente) {
          console.log('❌ Usuario no es docente, redirigiendo al home');
          // Si no es docente, redirigir al home
          next({ path: '/' })
          return
        }
        console.log('✅ Usuario es docente, permitiendo acceso');
      }
    } catch (error) {
      console.error('❌ Error verificando autenticación:', error);
      next({ 
        path: '/ingresar', 
        query: { redirect: to.fullPath }
      })
      return
    }
  } else {
    console.log('✅ Ruta pública, permitiendo acceso');
  }

  // Si no hay restricciones o se cumplen todas, continuar
  console.log('✅ Acceso permitido a:', to.path);
  next()
})

export default router